import { Theme, useTranslation, Pill, PillType, NextgenImage, LoaderType } from '@nextgen-web-framework/all';
import { SpecialOfferAlertMessageProps } from './types/propTypes';
import styles from './SpecialOfferAlertMessage.module.scss';

const { SUCCESS, PURPLE } = Theme;
const SpecialOfferAlertMessage = ({
  openOffersDrawer,
  selectedQuantity,
  totalSelectableQty,
}: SpecialOfferAlertMessageProps) => {
  const isSelectionComplete = selectedQuantity === totalSelectableQty;
  const t = useTranslation();

  return (
    <div className={`${styles['special-offer-alert']} ${isSelectionComplete && styles['green']}`}>
      <div className={styles['icon']}>
        <NextgenImage
          loaderType={LoaderType.WEBFONTS}
          isRelativeURL
          alt={t('promotion.specialOffer.drawerHeading')}
          src={`/icons/gift-${isSelectionComplete ? 'green' : 'purple'}.svg`}
          width={16}
          height={16}
        />
      </div>
      <div className={styles['content']}>
        <p className={styles['title']}>{t('promotion.specialOffer.alertHeading')}</p>
        <p className={styles['detail']}>{`(${selectedQuantity}/${totalSelectableQty} ${t(
          'promotion.specialOffer.alertProductsSelected',
        )})`}</p>
      </div>
      <Pill
        title={t(`promotion.specialOffer.${isSelectionComplete ? 'changeButton' : 'selectButton'}`)}
        pillType={PillType.SOLID}
        className={styles['pill']}
        theme={isSelectionComplete ? SUCCESS : PURPLE}
        onPillClick={openOffersDrawer}
      />
    </div>
  );
};

export default SpecialOfferAlertMessage;
